'use strict';
/**
 * Entry of the dying table containing sockets being removed.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var EDying =
/**
   * @param {string} peerId The identifier of the peer reachable through the
   * socket.
   * @param {object} socket The WebRTC socket.
   * @param {number} timeout Time before the connexion is completely removed
   * and destroyed.
   */
function EDying(peerId, socket, timeout) {
  _classCallCheck(this, EDying);

  this.peer = peerId; // key

  this.socket = socket;
  this.timeout = timeout;
};

;
module.exports = EDying;